module.exports = __webpack_public_path__ + "images/guangxi_banner03.jpg?6426d78c35c10bd81c271981f3665606";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/guangxi_banner03.jpg
// module id = 185
// module chunks = 1